import Component from "./Batches";
export default Component;  
